const validate = (attrs = {
  materiaPeriodo: {},
  contribucionMateria: '',
  fundamentacionMateria: '',
  valoresContemplados: '',
  metodologiaEnsenhanza: '',
  estrategiasEvauacion: '',
  objetivosMaterias: [],
  bibliografiaBasica: '',
  cronogramaClases: [],
  practicasLaboratorios: [],
  proyectosTrabajosPracticos: [],
  profesores: [],
}) => {
  const errors = {};

  if (attrs.materiaPeriodo && !attrs.materiaPeriodo.canEditarPlaneamiento) {
    return errors;
  }

  if (!attrs.contribucionMateria) {
    errors.contribucionMateria = 'Debe ingresar un valor';
  }

  if (!attrs.fundamentacionMateria) {
    errors.fundamentacionMateria = 'Debe ingresar un valor';
  }

  if (!attrs.valoresContemplados) {
    errors.valoresContemplados = 'Debe ingresar un valor';
  }

  if (!attrs.metodologiaEnsenhanza) {
    errors.metodologiaEnsenhanza = 'Debe ingresar un valor';
  }

  if (!attrs.estrategiasEvauacion) {
    errors.estrategiasEvauacion = 'Debe ingresar un valor';
  }

  if (!attrs.bibliografiaBasica) {
    errors.bibliografiaBasica = 'Debe ingresar un valor';
  }

  if (!attrs.objetivosMaterias || !attrs.objetivosMaterias.length) {
    errors.objetivosMaterias = { _error: 'Debe agregar un objetivo' };
  } else {
    errors.objetivosMaterias = [];
    attrs.objetivosMaterias.filter(o => !o.deleted).forEach((obj, index) => {
      const error = {};

      if (!obj.objetivo) {
        error.objetivo = 'Debe ingresar el objetivo';
      }

      if (Object.keys(error).length) {
        errors.objetivosMaterias[index] = error;
      }
    });
  }

  if (!attrs.cronogramaClases || !attrs.cronogramaClases.length) {
    errors.cronogramaClases = { _error: 'Debe agregar un cronograma' };
  } else {
    errors.cronogramaClases = [];
    attrs.cronogramaClases.filter(o => !o.deleted).forEach((obj, index) => {
      const error = {};

      if (!obj.contenidos) {
        error.contenidos = 'Debe ingresar los contenidos';
      }
      if (!obj.fecha) {
        error.fecha = 'Debe ingresar una fecha valida';
      }

      if (!obj.profesorMateria || !obj.profesorMateria.value) {
        error.profesorMateria = 'Debe seleccionar un profesor';
      } else if (!(attrs.profesores || []).some(p => p.id === obj.profesorMateria.value)) {
        error.profesorMateria = 'Debe seleccionar el profesor encaregado o auxiliar';
      }

      if (!obj.unidad) {
        error.unidad = 'Debe ingresar la unidad';
      }

      if (Object.keys(error).length) {
        errors.cronogramaClases[index] = error;
      }
    });
  }

  if (attrs.practicasLaboratorios && attrs.practicasLaboratorios.length) {
    errors.practicasLaboratorios = [];
    attrs.practicasLaboratorios.filter(o => !o.deleted).forEach((obj, index) => {
      const error = {};
      if (!obj.actividad) {
        error.actividad = 'Debe ingresar la actividad';
      }
      if (!obj.descripcion) {
        error.descripcion = 'Debe ingresar la descripcion';
      }

      if (!obj.profesorMateria || !obj.profesorMateria.value) {
        error.profesorMateria = 'Debe seleccionar un profesor';
      } else if (!(attrs.profesores || []).some(p => p.id === obj.profesorMateria.value)) {
        error.profesorMateria = 'Debe seleccionar el profesor encaregado o auxiliar';
      }

      if (!obj.duracion) {
        error.duracion = 'Debe seleccionar una duracion';
      }

      if (Object.keys(error).length) {
        errors.practicasLaboratorios[index] = error;
      }
    });
  }

  if (attrs.proyectosTrabajosPracticos && attrs.proyectosTrabajosPracticos.length) {
    errors.proyectosTrabajosPracticos = [];
    attrs.proyectosTrabajosPracticos.filter(o => !o.deleted).forEach((obj, index) => {
      const error = {};
      if (!obj.actividad) {
        error.actividad = 'Debe ingresar la actividad';
      }
      if (!obj.descripcion) {
        error.descripcion = 'Debe ingresar la descripcion';
      }
      if (!obj.evaluacion) {
        error.evaluacion = 'Debe ingresar una fecha valida';
      }

      if (!obj.profesorMateria || !obj.profesorMateria.value) {
        error.profesorMateria = 'Debe seleccionar un profesor';
      } else if (!(attrs.profesores || []).some(p => p.id === obj.profesorMateria.value)) {
        error.profesorMateria = 'Debe seleccionar el profesor encaregado o auxiliar';
      }

      if (!obj.duracion || !obj.duracion.value) {
        error.duracion = 'Debe seleccionar una duracion';
      }

      if (Object.keys(error).length) {
        errors.proyectosTrabajosPracticos[index] = error;
      }
    });
  }

  if (attrs.actividadesComplementarias && attrs.actividadesComplementarias.length) {
    errors.actividadesComplementarias = [];
    attrs.actividadesComplementarias.filter(o => !o.deleted).forEach((obj, index) => {
      const error = {};
      if (!obj.descripcionActividad) {
        error.descripcionActividad = 'Debe ingresar la actividad';
      }
      if (!obj.beneficiarios) {
        error.beneficiarios = 'Debe ingresar los beneficiarios';
      }
      if (!obj.fechas) {
        error.fechas = 'Debe ingresar las fechas';
      }
      if (!obj.cantidadHoras) {
        error.cantidadHoras = 'Debe ingresar la cantidad de horas';
      }

      if (Object.keys(error).length) {
        errors.actividadesComplementarias[index] = error;
      }
    });
  }

  if (Object.keys(errors).length) {
    // console.log(errors);
  }

  return errors;
};

export default validate;
